<template>
    <div class="address-item" :class="{ invalid }">
        <div class="info">
            <div v-if="address.name" class="name">
                {{ address.name }}
            </div>
            <div class="label">
                {{ address.formatted }}
            </div>
        </div>
        <div class="actions">
            <div v-if="invalid" class="warning">
                {{ config.PROFILE_ADDRESS_INVALID }}
            </div>
            <div>
                <Button
                    flat
                    small
                    type="button"
                    class="action"
                    :color="config.COLOR_PRIMARY"
                    @click="onEdit"
                >
                    <EditIcon :color="config.COLOR_PRIMARY"/>
                    <span>{{ config.PROFILE_EDIT_ADDRESS }}</span>
                </Button>
                <Button
                    flat
                    small
                    type="button"
                    class="action"
                    :color="config.COLOR_PRIMARY"
                    @click="onDelete"
                >
                    <TrashIcon :color="config.COLOR_PRIMARY"/>
                    <span>{{ config.PROFILE_DELETE_ADDRESS }}</span>
                </Button>
            </div>
        </div>
    </div>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import {
    EditIcon, TrashIcon,
} from '../svg';

export default {
    name: 'AddressItem',
    components: {
        TrashIcon,
        EditIcon,
    },
    mixins: [SolutionConsumer],
    props: {
        address: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        invalid () {
            const {
                street, country, city,
            } = this.address;
            return [street, country, city].some((field) => !field);
        },
    },
    methods: {
        onEdit () {
            this.$emit('onEdit', this.address);
        },
        onDelete () {
            this.$emit('onDelete', this.address);
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.address-item {
    @include card(10px 20px);
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    width: 100%;

    .info {
      padding: 10px;

      .name {
        color: $black;
        font-weight: 500;
        margin-bottom: 5px;
        overflow-wrap: anywhere;
      }

      .label {
        white-space: pre-line;
      }
    }

    .actions {
       display: flex;
       flex-direction: column;
       justify-content: center;
       border-left: 1px solid $grey-lightest;
       width: 150px;

      .warning {
        color: $red;
        font-size: 12px;
        padding-left: 20px;
        overflow-wrap: anywhere;
      }

      .action {
        line-height: 1rem !important;
        justify-content: flex-start !important;
        align-items: center !important;
        padding-left: 20px;
        min-width: auto;

        > svg {
          width: 14px;
          margin-right: 5px;
        }

        > span {
          line-height: 10px;
        }
      }
    }

  &.invalid {
    background: #fcf5f4;
    border: 1px solid $red;

    .actions {
      justify-content: space-between;

      .action:first-child > span {
        font-weight: 700;
      }
    }
  }

  @include breakpoint-max(sm) {
    .actions {
      width: 50%;
    }
  }
}
</style>
